import Vue from 'vue';

import { ApiService } from '@/services/api.service'
import { Log } from '@/services/log.service'
import { Factory } from '@/services/factory.service'
import { Finder } from '@/services/finder.service'
import { KombiRepository } from '@/repositories/KombiRepository'

import { store } from '@/store'
import { mapState } from 'vuex';
import router from '@/router'

export const BootService = new Vue({
	store,
	router,
	computed: {
		...mapState(['settings', 'globals']),
		...mapState('configurator', ['configurator', 'kombis', 'komponenten']),
	},

	methods: {

		/**
		 * 	Der Boot-Prozess:
		 * 	Wird in der main.js bei Initialisierung aufgerufen.
		 *
		 */
		init() {

			return new Promise((resolve, reject) => {

				// Lokale Voreinstellungen laden
				this.$store.dispatch('settings/LOAD').then( ({ data }) => {

					// ... danach API initialisieren
					ApiService.init();
					
					// ... settings.json laden
					ApiService.loadSettings().then(({ data }) => {

						this.$store.commit('settings/MODIFY', {presets:data});
						//Log.INFO( 'BootService.init()', 'Preset-Daten geladen', this.settings.presets );

						// ... configurator.json laden
						ApiService.loadConfiguratorData().then(({ data }) => {
							
							// Daten parsen, Modelle bauen und in Repos einfügen
							var result = Factory.parseConfiguratorData( data );

							//Log.INFO( 'BootService.init()', 'Configurator-Daten geladen und geparsed', result );
							
							Log.SUCCESS('BootService.init()', 'test', KombiRepository.findByCriteria({bereich:'topisch', kopf:'standard', flasche:'crimp'}) );

							resolve( {data:data} );

						}).catch( reject );

					}).catch( reject );

				}).catch( reject );
			})
		},

	}
});



// WEBPACK FOOTER //
// ./src/services/boot.service.js